import React from "react";
import { CertifierContentItemTemplate } from "themes/application/certifier/components";
import { observer } from "mobx-react";

const CertifierContentItem = observer(function CertifierContentItem(props) {
    return <CertifierContentItemTemplate {...props} />;
});

export default CertifierContentItem;
